export default class ProfileService {
    /* @ngInject */
    constructor(apiService) {
        this.apiService = apiService;
    }

    get() {
        return this.apiService.get(`/users/me/profile`).then((result) => result.data);
    }

    save(profile) {
        return this.apiService.put(`/users/me/profile`, profile).then((result) => result.data);
    }

    generateBackup() {
        return this.apiService.post(`/backup/export`).then((result) => result.data);
    }

    importBackup(file, dryRun = false) {
        const formData = new FormData();
        formData.append('file', file);
        const endpoint = dryRun
            ? `/backup/import?dryRun=true`
            : `/backup/import`;

        return this.apiService.post(endpoint, formData, {
            transformRequest: (data) => data,
            headers: {
                // eslint-disable-next-line no-undefined
                'Content-Type': undefined
            }
        }).then((result) => result.data);
    }

    export() {
        return this.apiService.post(`/export/simple-csv`).then((result) => result.data);
    }

    exportCsv() {
        return this.apiService.get(`/export/download`).then((result) => {
            window.open(result.data.url, '_blank');
        });
    }

    changeEmailWithToken(token) {
        return this.apiService.post(`/users/change-email`, {
            token
        }).then((result) => result.data);
    }

    updatePassword(oldPassword, newPassword) {
        return this.apiService.put(`/users/me/change-password`, {
            oldPassword,
            newPassword
        }).then((result) => result.data);
    }
}



// WEBPACK FOOTER //
// ./src/application/service/user/profile.service.js